import React from "react";
import { PrimaryButton } from "../utils/Button";

const Header = () => {
  return (
    <div className="header">
      <div className="container">
        <div className="header__container">
          <div className="logo__image">
            <img src="https://reviewpart.com/wp-content/uploads/2023/09/logo-2.png" />
          </div>
          <div>
            <PrimaryButton text={"buy now"} handler={() => alert("Buy Now")} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
